import { css } from '@emotion/core';

export const swipe = (open: boolean, isMain: boolean = false) => css`
	opacity: 1;

	transform: translateX(
		${open ? (isMain ? '-100%' : '0') : isMain ? '0' : '100%'}
	);
	transition: transform 0.35s linear;
`;
